/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-14 17:45:57
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-01-16 11:37:24
 * @FilePath: \baishu_react_ui\src\components\BsyBatchEditPane\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import { BsyWidget } from '../BsyWidget';
import './index.css'


import { BsyConfig } from '../../global/BsyConfig';


export default class BsyFieldsSelectPane extends BsyWidget {


    static defaultProps = {
        baseCls: "bsy-field-select-pane",
        mode: "pop-right",
        forms: [],
        entryList: {},
        fields: [],
        excludeField: ["separator", "button", "dataload", "linkquery", "linkdata", 'chargers'],
        systemField: ["createTime", 'creator', "backflowid", "flowNode", "flownode", "flowcreator", "flowstate", 'flow_chargers', "updateTime", "flowState", '_id', 'flowdecision', 'flowDecision', 'ext'
    ,'flow_assist.assist_charger','flow_assist.assist_flowid','flow_assist.assist_prostatus','flow_assist.assist_protime','flow_assist.assist_outtime' ],
        onFieldSelect: null,
        onFieldFilter: null,
        seachKey: null,
    }
    constructor(props) {
        super(props);

        this.state = {
            availableFields: BsyConfig().LimitFields.filter,
            text4add: React.language("field.linkFilter.add"),
            ...props,

        }

        this.element = React.createRef();
        this.formfoldMap = {}
        this.selectMap = {};
        props.fields.map(field => {
            this.selectMap[field.id + '.' + field.name] = field
        })
    }

    onItemClick = (field) => {
        if (this.selectMap[field.id + '.' + field.name]) {
            return;
        }
        const { fields } = this.state;
        let newField = [...fields];

        this.selectMap[field.id + '.' + field.name] = { ...field }
        newField.push(field);
        this.setState({
            fields: newField
        }, () => {
            this.props.onStopEdit && this.props.onStopEdit(this.state.fields)
        })
    }

    render() {
        const { entryList, systemField, seachKey, excludeField } = this.state;
        const { cssName } = this.options;
        return (
            <div className={cssName} ref={this.element}>
                <ul className={'menu-list'}>
                    {
                        Object.keys(entryList).map(id => {
                            let form = entryList[id];
                            if (!this.formfoldMap.hasOwnProperty(form.id)) {
                                this.formfoldMap[form.id] = true;
                            }

                            let fields = [];
                            for (let i = 0; i < form.fields.length; i++) {
                                if (form.fields[i].type === 'subform') {
                                    for (let j = 0; j < form.fields[i].items.length; j++) {
                                        const sName = form.fields[i].items[j].widget ? form.fields[i].items[j].widget.widgetName : form.fields[i].items[j].name;
                                        const sText = form.fields[i].items[j].widget ? form.fields[i].items[j].label : form.fields[i].items[j].text;
                                        fields.push({
                                            ...form.fields[i].items[j],
                                            id: form.fields[i].id,
                                            appId: form.fields[i].appId,
                                            entryId: form.fields[i].entryId,
                                            formId: form.fields[i].formId,
                                            designAppId: form.fields[i].designAppId,
                                            designEntryId: form.fields[i].designEntryId,
                                            designWidgetName: form.fields[i].designWidgetName,
                                            designSubform: form.fields[i].name,
                                            name: [form.fields[i].name, sName].join('.'),
                                            text: [form.fields[i].text, sText].join('.')
                                        })
                                    }
                                } else {
                                    fields.push(form.fields[i])
                                }
                            }


                            return <li className={'entry'}
                                key={form.id}
                            >
                                <span className="menu-item" title={form.name} onClick={() => {
                                    this.formfoldMap[form.id] = !this.formfoldMap[form.id];
                                    this.setState({})
                                }}>
                                    <i className="icon-form"></i><span>{form.name}</span>
                                </span>
                                <ul className={'field-list'} style={{
                                    display: this.formfoldMap[form.id] ? 'block' : 'none'
                                }}>
                                    {
                                        fields.map(field => {
                                            //过滤字段
                                            if (excludeField.length > 0) {
                                                if (excludeField.indexOf(field.type) > -1) {
                                                    return <></>
                                                }
                                            }
                                            //字段搜索
                                            if (seachKey) {
                                                if (field.text && field.text.indexOf(seachKey) === -1) {
                                                    return <></>
                                                }
                                            }
                                            return field.name !=="label" && <li
                                                title={field.text || field.title}
                                                key={field.id + '.' + field.name}
                                                className={"field " + (this.selectMap[field.id + '.' + field.name] ? " disabled " : '') + (systemField.indexOf(field.name) > -1 ? "bule" : '')}
                                                onClick={() => {
                                                    this.onItemClick(field)
                                                }}
                                            >{field.text || field.title}</li>
                                        })
                                    }
                                </ul>
                            </li>
                        })
                    }
                </ul>

            </div>
        );
    }
}
